import axiosInstance from './axiosConfig';

const API_URL = '/api/frames';

const getAllFrames = () => {
    return axiosInstance.get(API_URL);
};

const createFrame = (frameData) => {
    return axiosInstance.post(API_URL, frameData);
};

const updateFrame = (id, frameData) => {
    return axiosInstance.put(`${API_URL}/${id}`, frameData);
};

const deleteFrame = (id) => {
    return axiosInstance.delete(`${API_URL}/${id}`);
};

const frameService = {
    getAllFrames,
    createFrame,
    updateFrame,
    deleteFrame,
};

export default frameService;
